function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import Picker from 'rc-picker';
import { useEffect, useState } from 'react';
import { cn } from "../../../lib/utils";
import useSharedProps from "./hooks/useSharedProps";
import { DatePickerStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DatePicker = function DatePicker(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    label = props.label,
    status = props.status,
    errorText = props.errorText,
    isMobile = props.isMobile,
    fullWidth = props.fullWidth;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    _open = _useState2[0],
    setOpen = _useState2[1];
  var sharedProps = useSharedProps(props);
  DatePickerStyle({
    id: sharedProps.paramsID,
    size: size,
    theme: theme,
    status: status,
    fullWidth: fullWidth
  });
  useEffect(function () {
    var inputElement = document.querySelector(".".concat(sharedProps.prefixCls, "-input input"));
    var handleFocus = function handleFocus() {
      if (inputElement) {
        // @ts-ignore
        inputElement.blur();
      }
    };
    if (isMobile && document) {
      if (inputElement) {
        inputElement.addEventListener('focus', handleFocus);
      }
    }
    // 清理函数：移除focus事件监听器
    return function () {
      if (inputElement) {
        inputElement.removeEventListener('focus', handleFocus);
      }
    };
  }, []);
  var handleDisplayClick = function handleDisplayClick() {
    setOpen(function (_v) {
      return !_v;
    });
  };
  var handleSelect = function handleSelect(v) {
    setOpen(false);
    if (sharedProps.onSelect) {
      sharedProps.onSelect(v);
    }
  };
  var renderOpen = function renderOpen() {
    if (sharedProps.open === undefined) {
      if (sharedProps.displayElement) {
        return _open;
      } else {
        return undefined;
      }
    } else {
      return sharedProps.open;
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "moly-datepicker-wrapper-".concat(sharedProps.paramsID),
    children: [label && /*#__PURE__*/_jsx("div", {
      className: sharedProps.prefixCls + '-label',
      children: label
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(sharedProps.prefixCls, "-displayWrap"),
      onClick: handleDisplayClick,
      children: sharedProps.displayElement ? sharedProps.displayElement : null
    }), /*#__PURE__*/_jsx(Picker, _objectSpread(_objectSpread({}, sharedProps), {}, {
      open: renderOpen(),
      className: cn(_defineProperty(_defineProperty({}, sharedProps.prefixCls + '-status-error', status === 'error'), sharedProps.prefixCls + '-customize', !!sharedProps.displayElement)),
      onSelect: handleSelect,
      dropdownClassName: cn(sharedProps.dropdownClassName, _defineProperty({}, sharedProps.prefixCls + '-h5', isMobile))
    })), errorText && /*#__PURE__*/_jsx("div", {
      className: sharedProps.prefixCls + '-error-text',
      children: errorText
    })]
  });
};
export { DatePicker };